import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import { useSearchParams } from "react-router-dom";
import ChangePasswordPage from "../../../authentication/ChangePassword";
import SupervisorSessionsView from "./PrevousSessions";
import InProgressSessions from "./InProgressSessions";

export default function SupervisorSessionsInfoPage() {
  const LocalBasePath = "page.student.dashboard.personalInfo";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = [
    {
      name: t("inprogress"),
      content: <InProgressSessions page={+(searchParams.get("page") ?? 1)}/>,
    },
    {
      name: t("pervious"),
      content: (
        <SupervisorSessionsView page={+(searchParams.get("page") ?? 1)} />
      ),
    },
  ];
  return (
    <div className="w-full  flex flex-col gap-8   min-h-full">
      <div className=" p-4 px-8 divide-gray-300 text-gray-900 flex items-center justify-between">
        <h2 className="text-2xl ">{t("sessions")}</h2>
      </div>
      <TabsComponent
        requests={true}
        defaultTab={+(searchParams.get("tab") ?? 0)}
        tabs={tabs}
      />
    </div>
  );
}
